import { GQL } from "@binale-tech/shared";

import type { GenericRecord } from "@domain/models/GenericRecord";

type LinkedRecord = Pick<GenericRecord, "bankingTransactionId" | "cashRegisterTransactionId" | "cancellation">;

/** Ids of the Bank or Kasse transactions that have a record which is neither cancelled nor a counterweight. */
export const exportedTransactionIds = (
    kind: GQL.ITransactionExportKind,
    records: Iterable<LinkedRecord>,
): ReadonlySet<string> => {
    const ids = new Set<string>();
    for (const record of records) {
        if (record.cancellation) continue;
        const id =
            kind === GQL.ITransactionExportKind.Bank ? record.bankingTransactionId : record.cashRegisterTransactionId;
        if (id) ids.add(id);
    }
    return ids;
};
